/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc
 */
import * as References from './PriorityFeaturesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc#getPriorityFeatures
 */
export const GET_PRIORITY_FEATURES_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_PriorityFeaturesRpc_getPriorityFeatures';
export const GET_PRIORITY_FEATURES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRIORITY_FEATURES_QUERY_FIELD_NAME,
  args: ['productApiName', 'i18nLangLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPriorityFeaturesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc#getPriorityFeaturesBulk
 */
export const GET_PRIORITY_FEATURES_BULK_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_PriorityFeaturesRpc_getPriorityFeaturesBulk';
export const GET_PRIORITY_FEATURES_BULK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRIORITY_FEATURES_BULK_QUERY_FIELD_NAME,
  args: ['productApiNames', 'i18nLangLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPriorityFeaturesBulkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});